import { render, staticRenderFns } from "./FormBasicInfo.vue?vue&type=template&id=f74c3324&scoped=true&"
import script from "./FormBasicInfo.vue?vue&type=script&lang=js&"
export * from "./FormBasicInfo.vue?vue&type=script&lang=js&"
import style0 from "./FormBasicInfo.vue?vue&type=style&index=0&id=f74c3324&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f74c3324",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
installComponents(component, {VContainer,VForm,VListItem,VListItemContent})
